import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useIsMobileDimension } from "../../hooks/useGetDimensionGroup";
import { calculatePosition } from "../utils/calculatePosition";
export var withCalculatedPosition = function withCalculatedPosition(WrappedComponent) {
  return /*#__PURE__*/memo(function (props) {
    var dropdownRef = useRef(null);
    var _useState = useState('bottom'),
      _useState2 = _slicedToArray(_useState, 2),
      calculatedPosition = _useState2[0],
      setCalculatedPosition = _useState2[1];
    var isMobile = useIsMobileDimension();
    var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      dropdownMeasure = _useState4[0],
      setDropdownMeasure = _useState4[1];
    useEffect(function () {
      // устанавливаем таймер, чтобы getBoundingClientRect успел посчитать размер вместе с текстом элемента внутри
      var timerId = setTimeout(function () {
        if (dropdownRef.current) {
          setDropdownMeasure(dropdownRef.current.getBoundingClientRect());
        }
      }, 0);
      return function () {
        return clearTimeout(timerId);
      };
    }, []);
    useLayoutEffect(function () {
      var containerHeight = window.innerHeight;
      if (dropdownMeasure) {
        var calculatedPositionData = calculatePosition({
          dropdownRect: dropdownMeasure,
          containerHeight: containerHeight,
          isMobile: isMobile
        });
        setCalculatedPosition(calculatedPositionData);
      }
    }, [dropdownRef, isMobile, dropdownMeasure]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      calculatedPosition: calculatedPosition,
      dropdownRef: dropdownRef,
      "data-t-id": "DropdownList-hocs"
    }));
  });
};